import { useLocalStorage } from 'providers';
import { useEffect } from 'react';
import useQueryParameter from '../useQueryParameter';

const useRafLink = () => {
  const referralQueryString = useQueryParameter('raf');
  const { setToStorage } = useLocalStorage();

  useEffect(() => {
    if (referralQueryString) {
      setToStorage('storedReferralCode', referralQueryString);
    }
  }, [referralQueryString, setToStorage]);
};

export default useRafLink;
